import { render, staticRenderFns } from "./ProductInquiryReplied.vue?vue&type=template&id=6dc32c4c&"
import script from "./ProductInquiryReplied.vue?vue&type=script&lang=ts&"
export * from "./ProductInquiryReplied.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports